import { AbstractControl, ValidationErrors } from '@angular/forms';
import { AppError } from '../models';
import { ErrorReference } from '../enums';

export class StaticCommonValidator {
    static required(control: AbstractControl) {
        return control.value === '' || !control.value
            ? { required: new AppError(ErrorReference.pflichtfeldText) }
            : null;
    }

    static requiredRadio(control: AbstractControl): ValidationErrors | null {
        return control.value === '' || typeof control.value === 'undefined' || control.value === null
            ? { required: new AppError(ErrorReference.pflichtfeldRadio) }
            : null;
    }
    static requiredCheckbox(control) {
        return control.value === '' || !control.value
            ? { required: new AppError(ErrorReference.pflichtfeldCheckbox) }
            : null;
    }
    static requiredTrue(control: AbstractControl): ValidationErrors | null {
        return control.value && control.value === true
            ? null
            : { required: new AppError(ErrorReference.pflichtfeldText) };
    }

    static atLeastOne(control: AbstractControl) {
        return control.value === '' || !control.value || control.value.length === 0
            ? { required: new AppError(ErrorReference.pflichtfeldUpload) }
            : null;
    }
}
